/* Plume Ridge lesson booking (2026-09-24; URL prefill for AI quote links) */
(function () {
  var root = document.querySelector('[data-prb]');
  if (!root) return;

  var product, cfg;
  try { product = JSON.parse(root.querySelector('[data-prb-product]').textContent); } catch (e) { return; }
  try { cfg = JSON.parse(root.querySelector('[data-prb-config]').textContent) || {}; } catch (e) { cfg = {}; }

  var EN = /^en/i.test(document.documentElement.lang || '');
  var MAP = {
    '半日 3 小時': 'Half day · 3 h', '全日 6 小時（教學 5 小時）': 'Full day · 6 h (5 h teaching)',
    '全日 7 小時（教學 6 小時）': 'Full day · 7 h (6 h teaching)', '全日 5 小時': 'Full day · 5 h',
    '3 小時': '3 hours', '7 小時': '7 hours',
    '1–2 人': '1–2 people', '3–4 人': '3–4 people', '5–6 人': '5–6 people',
    '1 對 1': '1:1', '1 對 2': '1:2', '1 對 3': '1:3', '1 對 4': '1:4',
    '淡季': 'low season', '旺季': 'peak season', '聖誕／春節': 'Christmas / Lunar New Year', '平日': 'weekday',
    '札幌手稻 Teine': 'Sapporo Teine', '札幌國際 Kokusai': 'Sapporo Kokusai', '星野 Tomamu': 'Hoshino Tomamu',
    '富良野 Furano': 'Furano', '安比 APPI': 'APPI', '輕井澤 Karuizawa': 'Karuizawa', '苗場 Naeba': 'Naeba',
    '岩原 Iwappara': 'Iwappara', '白馬 Hakuba': 'Hakuba', '野澤 Nozawa': 'Nozawa Onsen', '志賀高原 Shiga Kogen': 'Shiga Kogen',
    '妙高 Myoko': 'Myoko', '赤倉 Akakura': 'Akakura', '藏王 Zao': 'Zao', '神居 Kamui': 'Kamui', '佐幌 Sahoro': 'Sahoro', '盤溪 Bankei': 'Bankei',
    '神樂 Kagura': 'Kagura', '舞子 Maiko': 'Maiko', '石打 Ishiuchi': 'Ishiuchi Maruyama', '湯澤 Yuzawa': 'Yuzawa'
  };
  function tr(v) { return EN && MAP[v] ? MAP[v] : v; }
  function slotLabel(v) { return EN ? String(v).replace(' 開始（全日）', ' start (full day)').replace(' 開始', ' start') : v; }
  var T = EN ? {
    choose: 'Please choose', jpy: 'JPY price ', jpyEb: ' (early bird) / regular ',
    season: function (s) { return 'This date is ' + tr(s) + '; the price has been updated.'; },
    hint: 'No date selected yet: showing the peak-season price. Pick a date and the price updates automatically.',
    noDate: 'Please choose a date.', range: function (a, b) { return 'Bookable dates are ' + a + ' to ' + b + '.'; },
    noWa: 'Please enter a WhatsApp number. Our consultant confirms your coach on WhatsApp.',
    noVariant: 'We could not find that option. Please choose again.', addFail: 'Could not add',
    failMsg: function (m) { return 'Could not add: ' + m + '. Please try again or WhatsApp a consultant.'; }
  } : {
    choose: '請選擇', jpy: '日圓報價 ', jpyEb: '（早鳥）／門市 ',
    season: function (s) { return '此日期屬「' + s + '」，價格已自動計算。'; },
    hint: '未選日期，暫以旺季價顯示；選擇日期後會自動按季節計價。',
    noDate: '請選擇上課日期。', range: function (a, b) { return '可預訂日期為 ' + a + ' 至 ' + b + '。'; },
    noWa: '請填寫可聯絡的 WhatsApp 電話，顧問會以 WhatsApp 確認教練。',
    noVariant: '找不到對應的課程，請重新選擇。', addFail: '加入失敗',
    failMsg: function (m) { return '未能加入：' + m + '。請稍後再試，或 WhatsApp 顧問。'; }
  };
  var SEASON_OPTION = '季節';
  var OPEN = cfg.open || '2026-11-28';
  var CLOSE = cfg.close || '2027-04-05';
  var EARLY_BIRD_END = '2026-09-30';

  var DEFAULT_SEASON = cfg.default_season || '旺季';
  function seasonOf(d) {
    if (cfg.season_mode === 'weekend') {
      var wd = new Date(d + 'T00:00:00').getDay();
      var peak = (cfg.peak_dates || []).indexOf(d) >= 0;
      return (wd === 0 || wd === 6 || peak) ? '旺季' : '平日';
    }
    function inR(a, b) { return d >= a && d <= b; }
    if (inR('2026-12-20', '2027-01-05') || inR('2027-02-03', '2027-02-11')) return '聖誕／春節';
    if (inR('2026-12-05', '2027-02-22')) return '旺季';
    return '淡季';
  }

  var optionNames = (product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  function valuesFor(name) {
    var i = optionNames.indexOf(name);
    if (i < 0) return [];
    var seen = [];
    product.variants.forEach(function (v) {
      var val = v.options[i];
      if (seen.indexOf(val) < 0) seen.push(val);
    });
    return seen;
  }

  var state = { '課程時數': null, '人數': null, date: '', season: null };

  var form = root.querySelector('[data-prb-form]');
  var msg = root.querySelector('[data-prb-msg]');
  var priceEl = root.querySelector('[data-prb-price]');
  var compareEl = root.querySelector('[data-prb-compare]');
  var jpyEl = root.querySelector('[data-prb-jpy]');
  var ebEl = root.querySelector('[data-prb-eb]');
  var seasonEl = root.querySelector('[data-prb-season]');
  var dateEl = root.querySelector('[data-prb-date]');
  var slotEl = root.querySelector('[data-prb-slot]');

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'HKD';
  var locale = document.documentElement.lang || 'zh-TW';
  function money(cents) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return currency + ' ' + Math.round(cents / 100); }
  }
  function yen(n) { return '¥' + Number(n).toLocaleString('en-US'); }

  function buildPills(name) {
    var wrap = root.querySelector('[data-prb-pills="' + name + '"]');
    var field = root.querySelector('[data-prb-opt="' + name + '"]');
    var vals = valuesFor(name);
    if (!wrap || !vals.length) { if (field) field.hidden = true; return; }
    field.hidden = false;
    vals.forEach(function (val, idx) {
      var id = 'prb-' + name + '-' + idx;
      var label = document.createElement('label');
      label.className = 'prb__pill';
      label.setAttribute('for', id);
      var input = document.createElement('input');
      input.type = 'radio'; input.name = 'prb-' + name; input.id = id; input.value = val;
      if (idx === 0) { input.checked = true; state[name] = val; }
      input.addEventListener('change', function () { state[name] = val; if (name === '課程時數') buildSlots(); update(); });
      var span = document.createElement('span'); span.textContent = tr(val);
      label.appendChild(input); label.appendChild(span);
      wrap.appendChild(label);
    });
  }

  function buildSlots() {
    var slots = (cfg.slots && cfg.slots[state['課程時數']]) || ['09:00 開始', '13:00 開始'];
    var prev = slotEl.value;
    slotEl.innerHTML = '';
    slots.forEach(function (s) {
      var o = document.createElement('option'); o.value = s; o.textContent = slotLabel(s); slotEl.appendChild(o);
    });
    if (slots.indexOf(prev) >= 0) slotEl.value = prev;
  }

  function currentVariant() {
    return product.variants.find(function (v) {
      return optionNames.every(function (n, i) {
        if (n === SEASON_OPTION) return v.options[i] === (state.season || DEFAULT_SEASON);
        if (state[n] == null) return true;
        return v.options[i] === state[n];
      });
    });
  }

  function update() {
    var v = currentVariant();
    if (!v) { priceEl.textContent = T.choose; compareEl.textContent = ''; return; }
    priceEl.textContent = money(v.price);
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    compareEl.textContent = onSale ? money(v.compare_at_price) : '';
    ebEl.hidden = !onSale;
    var jp = cfg.jpy && cfg.jpy[v.title];
    if (jp) {
      jpyEl.textContent = onSale ? (T.jpy + yen(jp[1]) + T.jpyEb + yen(jp[0])) : (T.jpy + yen(jp[0]));
    } else { jpyEl.textContent = ''; }
    var hint0 = EN ? ((cfg.en && cfg.en.season_hint) || T.hint) : (cfg.season_hint || T.hint);
    var basis = state.season ? T.season(state.season) : hint0;
    seasonEl.textContent = basis;
  }

  function todayPlus(n) {
    var d = new Date(); d.setDate(d.getDate() + n);
    var m = String(d.getMonth() + 1).padStart(2, '0'), day = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + m + '-' + day;
  }

  // init
  buildPills('課程時數');
  buildPills('人數');
  buildSlots();
  var LEAD = (typeof cfg.lead_days === 'number') ? cfg.lead_days : 2;
  var minDate = todayPlus(LEAD) > OPEN ? todayPlus(LEAD) : OPEN;
  dateEl.min = minDate; dateEl.max = CLOSE;

  if (Array.isArray(cfg.resorts) && cfg.resorts.length) {
    var rw = root.querySelector('[data-prb-resort-wrap]');
    var rs = root.querySelector('#prb-resort');
    rw.hidden = false;
    cfg.resorts.forEach(function (r) { var o = document.createElement('option'); o.value = r; o.textContent = tr(r); rs.appendChild(o); });
  }
  if (cfg.people_field) root.querySelector('[data-prb-people-wrap]').hidden = false;

  dateEl.addEventListener('change', function () {
    state.date = dateEl.value;
    state.season = dateEl.value ? seasonOf(dateEl.value) : null;
    update();
  });
  update();

  // AI 報價連結：網址參數預填（d 日期、h 時數、p 人數或 1 對 N、t 時間、r 雪場、l 語言、b 板種、lv 程度、n 學員人數、src 來源代碼、q 報價編號）
  var extraProps = {};
  (function prefill() {
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (!q || !q.toString()) return;
    function pick(name, test) {
      var inputs = root.querySelectorAll('input[name="prb-' + name + '"]');
      for (var i = 0; i < inputs.length; i++) {
        if (test(inputs[i].value)) { inputs[i].checked = true; state[name] = inputs[i].value; return true; }
      }
      return false;
    }
    function setSel(id, val) {
      var el = root.querySelector('#' + id);
      if (!el || !val) return;
      if (el.tagName === 'SELECT') {
        for (var k = 0; k < el.options.length; k++) {
          var o = el.options[k];
          if (o.value === val || o.textContent === val || o.value.indexOf(val) === 0) { el.selectedIndex = k; return; }
        }
      } else { el.value = String(val).slice(0, 60); }
    }
    var h = (q.get('h') || '').replace(/[^\d.]/g, '');
    if (h) { pick('課程時數', function (v) { return new RegExp('^(半日 |全日 )?' + h + ' 小時').test(v); }); buildSlots(); }
    var p = parseInt(q.get('p') || '', 10);
    if (p) {
      pick('人數', function (v) {
        var m = v.match(/^1 對 (\d+)/); if (m) return +m[1] === p;
        var r = v.match(/^(\d+)–(\d+) 人/); return r ? (p >= +r[1] && p <= +r[2]) : false;
      });
    }
    var d = q.get('d') || '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(d)) { dateEl.value = d; state.date = d; state.season = seasonOf(d); }
    var t = q.get('t') || '';
    if (t) { for (var j = 0; j < slotEl.options.length; j++) { if (slotEl.options[j].value.indexOf(t) === 0) { slotEl.selectedIndex = j; break; } } }
    setSel('prb-resort', q.get('r'));
    var LANG = { zh: '普通話', cmn: '普通話', mandarin: '普通話', yue: '粵語', cantonese: '粵語', en: 'English' };
    var l = (q.get('l') || '').toLowerCase(); setSel('prb-lang', LANG[l] || q.get('l'));
    var BOARD = { ski: '雙板 Ski', sb: '單板 Snowboard', snowboard: '單板 Snowboard', board: '單板 Snowboard' };
    var b = (q.get('b') || '').toLowerCase(); setSel('prb-board', BOARD[b] || q.get('b'));
    var LV = ['從未滑過', '初學', '初中級', '中級', '進階'];
    var lv = q.get('lv'); setSel('prb-level', /^[0-4]$/.test(lv || '') ? LV[+lv] : lv);
    var n = q.get('n'); if (n) setSel('prb-people', /^\d+$/.test(n) ? n + ' 人' : n);
    var src = q.get('src'); if (src) extraProps['_來源'] = String(src).slice(0, 40);
    var qr = q.get('q'); if (qr) extraProps['_報價編號'] = String(qr).slice(0, 40);
    update();
  })();

  function collect() {
    var props = {};
    if (!dateEl.value) return { error: T.noDate };
    if (dateEl.value < dateEl.min || dateEl.value > dateEl.max) return { error: T.range(dateEl.min, dateEl.max) };
    var wa = root.querySelector('#prb-wa');
    if (!wa.value.trim() || wa.value.replace(/\D/g, '').length < 7) return { error: T.noWa };
    var d = new Date(dateEl.value + 'T00:00:00');
    var wk = ['日', '一', '二', '三', '四', '五', '六'][d.getDay()];
    props['上課日期'] = dateEl.value + '（星期' + wk + '）';
    props['上課時間'] = slotEl.value;
    root.querySelectorAll('[data-prb-prop]').forEach(function (el) {
      if (el.closest('[hidden]')) return;
      var val = (el.value || '').trim();
      if (val) props[el.getAttribute('data-prb-prop')] = val;
    });
    props['_季節'] = state.season;
    Object.keys(extraProps).forEach(function (k) { props[k] = extraProps[k]; });
    var v = currentVariant();
    if (!v) return { error: T.noVariant };
    var extra = [];
    if (cfg.addons) {
      Object.keys(cfg.addons).forEach(function (field) {
        var map = cfg.addons[field] || {}; var val = props[field];
        if (val && map[val]) extra.push({ id: map[val], quantity: 1, properties: { '課程': product.title, '上課日期': props['上課日期'] } });
      });
    }
    return { id: v.id, properties: props, extra: extra };
  }

  function send(goCheckout) {
    msg.textContent = '';
    var data = collect();
    if (data.error) { msg.textContent = data.error; return; }
    var btns = root.querySelectorAll('.prb__btn');
    btns.forEach(function (b) { b.disabled = true; });
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: data.id, quantity: 1, properties: data.properties }].concat(data.extra || []) })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || T.addFail);
        window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + (goCheckout ? 'checkout' : 'cart');
      })
      .catch(function (e) {
        msg.textContent = T.failMsg(e.message);
        btns.forEach(function (b) { b.disabled = false; });
      });
  }

  form.addEventListener('submit', function (e) { e.preventDefault(); send(true); });
  root.querySelector('[data-prb-add]').addEventListener('click', function () { send(false); });
})();
